import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
// import loadMap from './utils/loadMap'

import _ from 'lodash'
import '@/plugin/axios'
import '@/mock/register'

import './assets/scss/init.scss'
import './assets/scss/layout.scss'
import './assets/scss/transition.scss'
import './assets/scss/value.scss'
import './assets/scss/style.scss'

Vue.config.productionTip = false
Vue.prototype._ = _

async function createApp () {
  // try {
  //   const AMap = await loadMap()
  //   window.AMap = AMap
  // } catch (err) {
  //   console.log(err)
  // }
  return new Vue({
    router,
    store,
    render: h => h(App)
  }).$mount('#app')
}

createApp().then(r => {
})
